import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  assetTypes,
  fetchSuccess,
  fetchFailure,
  fetchAllAssetsForMapSuccess,
  fetchDeviceTypesSuccess,
  fetchDeviceTypesFailure,
  fetchDeviceNamesSuccess,
  fetchDeviceNamesFailure,
  deleteSuccess,
  deleteFailure,
  fetchDeviceProfilesSuccess,
  fetchDeviceProfilesFailure,
  createSuccess,
  createFailure,
  updateSuccess,
  updateFailure,
  fetchLocationsSuccess,
  fetchLocationsFailure,
  downloadImageSuccess,
  downloadImageFailure,
  fetchLocationAlertsResponse,
  fetchSingleDeviceTypesSuccess,
  fetchSingleDeviceTypesFailure,
  fetchDeviceDetailsSuccess,
  fetchDeviceDetailsFailure,
  floorViewSuccess,
  floorViewFailure,
} from "../actions/asset";
import {
  fetchAssetEndpoint,
  fetchDeviceTypesEndPoint,
  fetchv1DeviceDetailsEndPoint,
  deleteAssetEndpoint,
  fetchDeviceProfileEndPoint,
  createAssetEndpoint,
  updateAssetEndpoint,
  fetchLocationEndPoint,
  fetchImageEndPoint,
  //fetchDeviceDetailsEndPoint,
  //fectchOrgLocEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
//import getAddressfromLatLong from "../../global/utility/getAddressfromLatLong";
import { locationsToLocationZones, isAssetActiveInZone } from "../../pages/Assets/common/utils/utils";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import getAddressfromLatLong from "../../global/utility/getAddressfromLatLong";
import {
  fetchLocationAlertsAsset,
  createMetricsFromResponseForAsset,
} from "../../../src/global/utility/Utils";
import { v4 as uuidv4 } from "uuid";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
function* downloadSaga(action) {
  try {
    const response = yield call(fetchAssetAPI, action.filter);
    if (action.payload === "assetList")
      JSONToCSVDownload(
        assetCSVFormat(response?.pagination?.assets),
        "assetList_download.csv"
      );
    // yield put(downloadSuccess([...response]));
  } catch (error) {
    // yield put(downloadFailure(error.message));
  }
}

function* fetchLocationAlertsSaga(req) {
  try {
    if (!req?.payload) throw new Error("Invalid payload");
    const { assetId, startTime, endTime, deviceId, originCoord, metrics } =
      req?.payload;

    const resp = yield call(
      fetchLocationAlertsAsset,
      deviceId,
      startTime,
      endTime,
      assetId
    );
    if (!resp?.data) {
      throw new Error("Invalid response from server");
    }
    let mergedData = createMetricsFromResponseForAsset(resp.data);
    if (Array.isArray(mergedData) && mergedData.length > 0) {
      const address = yield call(
        getAddressfromLatLong, 
        mergedData[0]?.latitude, 
        mergedData[0]?.longitude
      );
      mergedData[0] = {
        ...mergedData[0],
        address,
      };
    }
    //   {
    //   data: resp.data,
    //   originCoord,
    //   metrics,
    //   type: "No Type Required",
    //   alertType: "No alert type required",
    // });
    yield put(fetchLocationAlertsResponse(mergedData));
  } catch (error) {
    console.error("Error fetching location alerts:", error);
    yield put(fetchLocationAlertsResponse([]));
  }
}

function* fetchAssetSaga(action) {
  try {
    const id = action.payload;
    const { pagination, filters, $sort, isFloorView } = yield select(
      (state) => ({
        pagination: {
          page: id ? 0 : state.asset.data.currentPage,
          limit: id ? 0 : state.asset.data.pageSize,
        },
        filters: state.asset.filters,
        $sort: state.asset.data.query.$sort,
        isFloorView: state.asset.ui.isFloorView,
      })
    );
  
    let filter = { ...applyFilter(filters), $sort };
    
    if (id) {
      filter = {
        ...filter,
        assetid: id,
        $sort: [{ field: "createdon", order: "desc" }],
      };
    } else if (!Array.isArray(filter?.assetid)) {
      delete filter.assetid;
    }

    const assetsResponses = yield call(fetchAssetAPI, {
      pagination,
      filter,
    });

    let currentaddress = null;
    let deviceData = {};
    let { selectedLocation, floorIndex } = yield select((state) => ({
      selectedLocation: state?.asset?.ui?.selectedLocation || null,
      floorIndex: state?.asset?.ui?.floorView?.selectedIndex || 0,
    }));
    let height = "450px";

    if (isFloorView && id && assetsResponses?.pagination?.assets.length > 0) {
      height = "70vh";
      const uniqueLocations = yield select(
        (state) => state.asset.data.uniqueLocations
      );
      selectedLocation = uniqueLocations.find(
        (location) =>
          location.name ===
          assetsResponses?.pagination?.assets?.[0]?.locationzone?.split(
            " - "
          )?.[0]
      );
      //get current location from assets response
      const currentLocation =
        assetsResponses?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.currentlocation ||
        assetsResponses?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.location ||
        null;

      //set floors zones from assets response
      if (
        selectedLocation &&
        Array.isArray(selectedLocation?.floors) &&
        selectedLocation?.floors.length > 0 &&
        currentLocation &&
        currentLocation?.floor &&
        currentLocation?.floor?.zone
      ) {
        const floorIndex = selectedLocation?.floors?.findIndex(
          (floor) => floor?.id === currentLocation?.floor?.id
        );

        if (floorIndex !== -1) {
          let zones = selectedLocation.floors[floorIndex].zones || [];
          const zoneIndex = selectedLocation?.floors[
            floorIndex
          ]?.zones?.findIndex(
            (zone) => zone?.id === currentLocation?.floor?.zone?.id
          );
          zones[zoneIndex] = currentLocation?.floor?.zone;

          if (Array.isArray(zones) && zones.length > 0) {
            zones = zones?.filter((z) => z.id);
          }

          zones = zones
            .map((zone) => {
              if (!zone.addgateway) {
                return zone;
              }
              zone.deviceCount =
                assetsResponses?.pagination?.assets?.filter((asset) =>
                  {
                    if(!asset?.locationzone?.endsWith(zone.zone_name)) return false;
                    if(isAssetActiveInZone(asset)) return false;
                    return true;
                  }
                )?.length || 0;

              return zone;
            })
            .filter((z) => z.deviceCount > 0);

          selectedLocation.floors = [
            {
              ...currentLocation?.floor,
              zones,
            },
          ];
        }
      }

      if (
        selectedLocation &&
        Array.isArray(selectedLocation?.floors) &&
        selectedLocation?.floors.length > 0
      ) {
        const floor = selectedLocation?.floors[0];
        if (floor && floor?.floorImageId) {
          const imageUrl = yield call(downloadImageAPI, floor.floorImageId);
          selectedLocation.floors[0] = {
            ...floor,
            imageUrl,
          };
        }
      }

      deviceData = yield call(
        fetchAssetDeviceNameAPI,
        assetsResponses.pagination.assets[0].deviceid
      );
      deviceData = deviceData?.devices?.[0] || {};
      if (
        deviceData?.fields?.location &&
        Object.hasOwn(deviceData?.fields?.location, "latitude") &&
        Object.hasOwn(deviceData?.fields?.location, "longitude")
      ) {
        currentaddress = yield call(
          getAddressfromLatLong,
          deviceData.fields.location.latitude,
          deviceData.fields.location.longitude
        );
      }
    } else if (
      isFloorView &&
      selectedLocation &&
      Array.isArray(selectedLocation?.floors) &&
      selectedLocation?.floors.length > 0 &&
      floorIndex < selectedLocation?.floors.length
      //assetsResponses?.pagination?.assets.length > 0
    ) {
      //get current location from assets response
      const currentLocation =
        assetsResponses?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.currentlocation ||
        assetsResponses?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.location ||
        null;

      let zones = selectedLocation.floors[floorIndex].zones || [];

      //set floors zones from assets response
      if (
        selectedLocation &&
        Array.isArray(selectedLocation?.floors) &&
        selectedLocation?.floors.length > 0 &&
        currentLocation &&
        currentLocation?.floor &&
        currentLocation?.floor?.zone
      ) {
        let zoneIndex = selectedLocation?.floors[floorIndex]?.zones?.findIndex(
          (zone) => zone?.id === currentLocation?.floor?.zone?.id
        );

        if (zoneIndex === -1) {
          zoneIndex = 0;
        }

        zones[zoneIndex] = currentLocation?.floor?.zone;

        if (Array.isArray(zones) && zones.length > 0) {
          zones = zones?.filter((z) => z.id);
        }

        zones = zones
          .map((zone) => {
            if (!zone.addgateway) {
              return zone;
            }

            zone.deviceCount =
              assetsResponses?.pagination?.assets?.filter((asset) =>
                asset?.locationzone?.endsWith(zone.zone_name)
              )?.length || 0;

            return zone;
          })
          .filter((z) => z.deviceCount > 0);
      } else {
        zones = zones.map((zone) => {
          zone.deviceCount = 0;
          return zone;
        });
      }

      selectedLocation.floors[floorIndex] = {
        ...selectedLocation.floors[floorIndex],
        zones,
      };
    }

    yield put(
      fetchSuccess({
        data: {
          count: assetsResponses.pagination.totalRecords,
          assetList: assetsResponses.pagination.assets,
          deviceDetails: deviceData || {},
          address: currentaddress,
        },
        selectedLocation,
        height,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

function applyFilter(filters) {
  const appliedFilters = {};
  const filterArray = Object.entries(filters);

  for (const [key, value] of filterArray) {
    if (
      value?.option &&
      Array.isArray(value?.option) &&
      value?.option?.length > 0
    ) {
      if (
        key === "assetid" &&
        Array.isArray(value?.option) &&
        typeof value?.option[0] === "string"
      ) {
        appliedFilters[key] = value?.option || [];
      } else {
        const havingArrayFilter = value?.option
          ?.filter((item) => item.value)
          ?.map((item) =>
            item?.text?.toLowerCase() === "no alert"
              ? "OK"
              : item.text.toUpperCase()
          );
        if (havingArrayFilter?.length > 0) {
          appliedFilters[key] = havingArrayFilter;
        }
      }
    } else if (typeof value?.option === "string") {
      if (value?.option !== "") {
        appliedFilters[key] = value?.option;
      }
    } else if (typeof value?.option === "object" && value?.option !== null) {
      const { lastupdatedfrom, lastupdatedto } = value?.option;
      if (lastupdatedfrom && lastupdatedto) {
        const fromDate = dayjs(lastupdatedfrom)
          .utc()
          .startOf("day")
          .toISOString();
        const toDate = dayjs(lastupdatedto).utc().endOf("day").toISOString();
        appliedFilters["lastupdatedfrom"] = fromDate;
        appliedFilters["lastupdatedto"] = toDate;
      } else if (lastupdatedfrom) {
        const fromDate = dayjs(lastupdatedfrom)
          .utc()
          .startOf("day")
          .toISOString();
        appliedFilters["lastupdatedfrom"] = fromDate;
      } else if (lastupdatedto) {
        const toDate = dayjs(lastupdatedto).utc().endOf("day").toISOString();
        appliedFilters["lastupdatedto"] = toDate;
      }
    }
  }
  return appliedFilters;
}

function* fetchDeviceDetails() {
  try {
    let deviceNames = yield call(fetchAssetDeviceDetailsAPI);
    if (
      Array.isArray(deviceNames?.devices) &&
      deviceNames?.devices?.length > 0
    ) {
      deviceNames = deviceNames.devices;
    }
    yield put(fetchDeviceDetailsSuccess(deviceNames));
  } catch (error) {
    yield put(fetchDeviceDetailsFailure(error.message));
  }
}

async function fetchAssetDeviceDetailsAPI() {
  try {
    const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: {
          $sort: [
            {
              field: "createdon",
              order: "desc",
            },
          ],
        },
      }),
    });
    return response.json();
  } catch (error) {
    return [];
  }
}

async function fetchAssetDeviceNameAPI(deviceid) {
  try {
    const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: {
          $sort: [
            {
              field: "createdon",
              order: "desc",
            },
          ],
        },
        resourceIdentifier: { deviceid },
        // $limitnumber: 500,
        // $pagenumber: 0,
        //  $filter: "($/customdata/isAvailable eq true)",
      }),
    });
    return response.json();
  } catch (error) {
    return [];
  }
}

async function fetchAssetAPI(payload) {
  if (payload.filter && payload.filter.assetstatus) {
    payload.filter.assetstatus = payload.filter.assetstatus.map((status) =>
      status === "CRITICAL" ? "ERROR" : status
    );
  }

  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: {
      $sort: [{ field: "createdon", order: "desc" }],
      ...payload.filter,
    },
    ...payload.pagination,
  };

  const response = await fetch(fetchAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

function* fetchAllAssetSagaForMap(action) {
  try {
    const id = action.payload;
    const { filters, $sort } = yield select((state) => ({
      filters: state.asset.filters,
      $sort: state.asset.data.query.$sort,
    }));

    let filter = { ...applyFilter(filters), $sort };
    if (id) {
      filter = {
        ...applyFilter({ ...filters, assetid: { option: id, sort: "asc" } }),
        $sort,
      };
    } else if (!Array.isArray(filter?.assetid)) {
      delete filter.assetid;
    }
    const assetsAllResponses = yield call(fetchAllAssetSaga, {
      filter,
    });
    yield put(
      fetchAllAssetsForMapSuccess({
        data: {
          allAssetsListData: assetsAllResponses.pagination.assets,
        },
      })
    );
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}

async function fetchAllAssetSaga(payload) {
  if (payload.filter && payload.filter.assetstatus) {
    payload.filter.assetstatus = payload.filter.assetstatus.map((status) =>
      status === "CRITICAL" ? "ERROR" : status
    );
  }
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: {
      $sort: [{ field: "createdon", order: "desc" }],
      ...payload.filter,
    },
  };

  const response = await fetch(fetchAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();
  return result;
}

function* fetchDeviceTypesSaga() {
  try {
    let deviceTypes = yield call(fetchDeviceTypesAPI);
    if (
      Array.isArray(deviceTypes?.devicetypes) &&
      deviceTypes?.devicetypes?.length > 0
    ) {
      deviceTypes = deviceTypes?.devicetypes.filter(
        (type) => type?.devicemodel?.toLowerCase() === "ble"
      );
    }

    yield put(fetchDeviceTypesSuccess(deviceTypes));
  } catch (error) {
    yield put(fetchDeviceTypesFailure(error.message));
  }
}
function* fetchSingleDeviceTypesSaga(action) {
  try {
    const devicetype = action.payload;
    let deviceTypes = yield call(fetchSingleDeviceTypesAPI, devicetype);
    // if (
    //   Array.isArray(deviceTypes?.devicetypes) &&
    //   deviceTypes?.devicetypes?.length > 0
    // ) {
    //   deviceTypes = deviceTypes?.devicetypes.filter(
    //     (type) => type?.devicemodel?.toLowerCase() === "ble"
    //   );
    // }
    yield put(fetchSingleDeviceTypesSuccess(deviceTypes));
  } catch (error) {
    console.log("error", error);
    yield put(fetchSingleDeviceTypesFailure(error.message));
  }
}

async function fetchSingleDeviceTypesAPI(payload) {
  const response = await fetch(fetchDeviceTypesEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: {
        devicetype: payload,
      },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

async function fetchDeviceTypesAPI() {
  const response = await fetch(fetchDeviceTypesEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({ accountName: sessionStorage.getItem("accountId") }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

function* fetchDeviceNamesSaga() {
  try {
    const isEdit = yield select(
      (state) => state?.asset?.ui?.selectedAsset?.opType === "edit"
    );
    let deviceNames = yield call(fetchDeviceNamesAPI, isEdit);
    if (
      Array.isArray(deviceNames?.devices) &&
      deviceNames?.devices?.length > 0
    ) {
      deviceNames = deviceNames?.devices;
    }

    yield put(fetchDeviceNamesSuccess(deviceNames));
  } catch (error) {
    yield put(fetchDeviceNamesFailure(error.message));
  }
}

async function fetchDeviceNamesAPI(isEdit) {
  let filter = {
    $sort: [{ field: "createdon", order: "desc" }],
  };

  if (!isEdit) {
    filter = { ...filter, $selection: "($/customdata/isAvailable eq true)" };
  }

  const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter,
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

function* fetchDeviceProfilesSaga(action) {
  try {
    const devicetype = action.payload;
    let deviceProfiles = yield call(fetchDeviceProfilesAPI, devicetype);
    if (
      Array.isArray(deviceProfiles?.deviceprofiles) &&
      deviceProfiles?.deviceprofiles?.length > 0
    ) {
      deviceProfiles = deviceProfiles?.deviceprofiles;
    }

    yield put(fetchDeviceProfilesSuccess(deviceProfiles));
  } catch (error) {
    yield put(fetchDeviceProfilesFailure(error.message));
  }
}

async function fetchDeviceProfilesAPI(devicetype) {
  const $filter = { profiletype: "nonshipment" };
  if (devicetype) {
    $filter.devicetype = [devicetype];
  }
  const response = await fetch(fetchDeviceProfileEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      $sort: [{ field: "profilename", order: "asc" }],
      accountName: sessionStorage.getItem("accountId"),
      $filter,
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

//fetch locations saga
function* fetchLocationsSaga() {
  try {
    let locations = yield call(fetchLocationsAPI);
    if (
      Array.isArray(locations?.locations) &&
      locations?.locations?.length > 0
    ) {
      locations = locations?.locations;
    }
    const locationZones = locationsToLocationZones(locations);

    yield put(fetchLocationsSuccess(locationZones));
  } catch (error) {
    console.log("error", error);
    yield put(fetchLocationsFailure(error.message));
  }
}

async function fetchLocationsAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: {
        $sort: [
          {
            field: "name",
            order: "asc",
          },
        ],
        fields: {
          createtype: "inventory_location",
        },
      },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}
const assetCSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    name: json.assetname,
    id: json.assetid,
    creationDate: json.createdon,
    lastUpdated: json.updatedat,
    assetType: json.assetType,
    activeStatus: json.assetstatus,
  }));
};

//create asset saga
function* createAssetSaga() {
  try {
    const { formData, createdby } = yield select((state) => ({
      formData: state.asset.ui.formData,
      createdby: state.auth?.user?.userName || "",
    }));
    const newAsset = yield call(createAssetAPI, {
      assetname: formData?.step1?.assetName,
      description: formData?.step1?.description,
      devicetype: formData?.step2?.deviceType,
      deviceid: formData?.step2?.deviceId?.id,
      devicename: formData?.step2?.deviceId?.name,
      bleserial: formData?.step2?.bleserial,
      deviceprofile: {
        id: formData?.step2?.deviceProfile?.id,
        profilename: formData?.step2?.deviceProfile?.name,
      },
      location: formData?.step3?.location,
      locationzone: formData?.step3?.locationZone,
      assettype: formData?.step3?.assetType,
      assetmodel: formData?.step3?.assetModel,
      assetserialnumber: formData?.step3?.assetSerialNumber,
      assetowner: formData?.step3?.assetOwner,
      createdby,
    });
    yield put(createSuccess(newAsset));
  } catch (error) {
    yield put(createFailure(error.message));
  }
}

async function createAssetAPI(formData) {
  const response = await fetch(createAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
      "X-Transaction-Id": uuidv4(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      ...formData,
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

function* updateAssetSaga() {
  try {
    const { formData, selectedAsset, createdby } = yield select((state) => ({
      formData: state.asset.ui.formData,
      selectedAsset: state.asset.ui.selectedAsset,
      createdby: state.auth?.user?.userName || "",
    }));
    const newDeviceId = formData?.step2?.deviceId?.id;
    const currentDeviceId = selectedAsset.deviceid;

    const payload = {
      accountName: sessionStorage.getItem("accountId"),
      assetid: selectedAsset.id,
      assetname: formData?.step1?.assetName,
      description: formData?.step1?.description,
      devicetype: formData?.step2?.deviceType,
      deviceid: newDeviceId,
      devicename: formData?.step2?.deviceId?.name,
      bleserial: formData?.step2?.bleserial,
      deviceprofile: {
        id: formData?.step2?.deviceProfile?.id,
        profilename: formData?.step2?.deviceProfile?.name,
      },
      locationzone: formData?.step3?.locationZone,
      location: formData?.step3?.location,
      assettype: formData?.step3?.assetType,
      assetmodel: formData?.step3?.assetModel,
      assetserialnumber: formData?.step3?.assetSerialNumber,
      assetowner: formData?.step3?.assetOwner,
      createdby,
    };

    if (newDeviceId && currentDeviceId && newDeviceId !== currentDeviceId) {
      payload.olddeviceid = currentDeviceId;
    }
    const updatedAsset = yield call(updateAssetAPI, payload);
    yield put(updateSuccess(updatedAsset));
  } catch (error) {
    yield put(updateFailure(error.message));
  }
}

async function updateAssetAPI(payload) {
  const response = await fetch(updateAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
      "X-Transaction-Id": uuidv4(),
    },
    method: "PATCH",
    body: JSON.stringify(payload),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

//delete asset saga
function* deleteAssetSaga() {
  try {
    const selectedAsset = yield select((state) => state.asset.ui.selectedAsset);
    yield call(deleteAssetAPI, selectedAsset.id);
    yield put(deleteSuccess());
  } catch (error) {
    yield put(deleteFailure(error.message));
  }
}

async function deleteAssetAPI(assetid) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    assetid,
  };
  const response = await fetch(deleteAssetEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "DELETE",
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}

function* downloadImageSaga(action) {
  try {
    const imageId = action.payload;
    if (!imageId) throw new Error("Image ID is required");
    let { uniqueLocations, floors, locationId } = yield select((state) => ({
      uniqueLocations: state?.asset?.data?.uniqueLocations,
      locationId: state?.asset?.ui?.selectedLocation?.id,
      floors: state?.asset?.ui?.selectedLocation?.floors,
    }));

    if (!locationId) throw new Error("Please select a location");
    if (!Array.isArray(floors) || floors?.length < 1)
      throw new Error("No floors found for the selected location");

    const locationIndex = uniqueLocations.findIndex(
      (loc) => loc.id === locationId
    );
    if (locationIndex === -1)
      throw new Error("No location found for the selected location ID");
    const floorIndex = floors.findIndex((f) => f.floorImageId === imageId);

    if (floorIndex === -1)
      throw new Error("No floor found for the selected image ID");
    let floor = floors.find((f) => f.floorImageId === imageId);

    if (!floor)
      throw new Error("No floor list found for the selected image ID");

    const imageUrl = yield call(downloadImageAPI, imageId);

    floors[floorIndex] = { ...floor, imageUrl };
    uniqueLocations[locationIndex] = {
      ...uniqueLocations[locationIndex],
      floors,
    };

    yield put(
      downloadImageSuccess({
        uniqueLocations,
        selectedLocation: uniqueLocations[locationIndex],
      })
    );
  } catch (error) {
    console.log("error in downloadImageSaga", error);
    yield put(downloadImageFailure(error.message));
  }
}

async function downloadImageAPI(imageId) {
  const response = await fetch(fetchImageEndPoint(), {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      resourceidentifier: {
        id: imageId,
      },
    }),
  });

  if (!response.ok) return null;
  const blob = await response.blob();
  const imageObjectURL = URL.createObjectURL(blob);
  return imageObjectURL;
}

function* floorViewSaga(action) {
  try {
    const locationObj = action?.payload?.location;

    if (!locationObj) throw new Error("Location is required");
    let floorIndex = action?.payload?.floorIndex || 0;
    let uniqueLocations = yield call(fetchLocationsAPI);
    if (
      Array.isArray(uniqueLocations?.locations) &&
      uniqueLocations?.locations?.length > 0
    ) {
      uniqueLocations = uniqueLocations?.locations;
    }

    uniqueLocations = uniqueLocations.reduce((acc, cur) => {
      let floors = Object.values(cur.floors);
      const newFloors = [];

      for (let i = 0; i < floors.length; i++) {
        let floor = JSON.parse(JSON.stringify(floors[i])); // Deep copy to avoid mutation
        if (floor?.zones && Object.values(floor?.zones).length > 0) {
          floor.zones = Object.values(floor?.zones);
        }

        newFloors.push(floor);
      }
      return [
        ...acc,
        { ...structuredClone(cur), floors: structuredClone(newFloors) },
      ];
    }, []);

    //set locationObj to selectedLocation
    let selectedLocation = uniqueLocations?.find(
      (location) => location.id === locationObj.id
    );

    const locationZoneArr = yield select((state) =>
      state.asset.filters?.locationzone?.option?.toString()?.split(" - ")
    );

    if (Array.isArray(locationZoneArr) && locationZoneArr.length > 0) {
      const locationName = locationZoneArr[0];
      const floorName = locationZoneArr[1];
      const locationFromFilter = uniqueLocations.find(
        (loc) => loc.name === locationName
      );
      const selectedFloorIndex =
        locationFromFilter?.floors?.findIndex(
          (floor) => floor?.name === floorName
        ) || 0;

      floorIndex = selectedFloorIndex !== -1 ? selectedFloorIndex : floorIndex;
    }

    const floorViewData = yield call(fetchAssetAPI, {
      pagination: {},
      filter: {
        locationzone: `${selectedLocation.name} - ${selectedLocation?.floors[floorIndex]?.name} `,
      },
    });

    if (
      Array.isArray(floorViewData?.pagination?.assets) &&
      floorViewData?.pagination?.assets?.length > 0
    ) {
      //get current location from assets response
      const currentLocation =
        floorViewData?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.currentlocation ||
        floorViewData?.pagination?.assets?.find(
          (asset) => asset.locationzone !== null
        )?.location ||
        null;

      //set floors zones from assets response
      if (
        selectedLocation &&
        Array.isArray(selectedLocation?.floors) &&
        selectedLocation?.floors.length > 0 &&
        currentLocation &&
        currentLocation?.floor &&
        currentLocation?.floor?.zone
      ) {
        // const floorIndex = selectedLocation?.floors?.findIndex(
        //   (floor) => floor?.id === currentLocation?.floor?.id
        // );

        if (floorIndex !== -1) {
          let zones = selectedLocation.floors[floorIndex].zones || [];
          const zoneIndex = selectedLocation?.floors[
            floorIndex
          ]?.zones?.findIndex(
            (zone) => zone?.id === currentLocation?.floor?.zone?.id
          );
          zones[zoneIndex] = currentLocation?.floor?.zone;

          if (Array.isArray(zones) && zones.length > 0) {
            zones = zones?.filter((z) => z.id);
          }

          zones = zones.map((zone) => {
            if (!zone.addgateway) {
              return zone;
            }

            zone.deviceCount =
              floorViewData?.pagination?.assets?.filter((asset) =>
                  {
                    if(!asset?.locationzone?.endsWith(zone.zone_name)) return false;
                    if(isAssetActiveInZone(asset)) return false;
                    return true;
                  }
              )?.length || 0;

            return zone;
          });

          selectedLocation.floors[floorIndex] = {
            ...currentLocation?.floor,
            zones,
          };
        }
      }
    }

    if (
      selectedLocation &&
      Array.isArray(selectedLocation?.floors) &&
      selectedLocation?.floors.length > 0
    ) {
      const floor = selectedLocation?.floors[floorIndex];
      if (floor && floor?.floorImageId) {
        const imageUrl = yield call(downloadImageAPI, floor.floorImageId);
        selectedLocation.floors[floorIndex] = {
          ...floor,
          imageUrl,
        };
      }
    }

    yield put(
      floorViewSuccess({
        selectedLocation,
        floorIndex,
      })
    );
  } catch (error) {
    console.log("error in floorViewSaga", error);
    yield put(floorViewFailure(error.message));
  }
}

export function* FetchAssetSaga() {
  yield takeLatest(assetTypes.FETCH_REQUEST, fetchAssetSaga);
}

export function* FetchAllAssetSagaForMap() {
  yield takeLatest(assetTypes.FETCH_REQUEST, fetchAllAssetSagaForMap);
}

export function* FetchLocationAlertsSaga() {
  yield takeLatest(
    assetTypes.FETCH_LOCATION_ALERTS_REQUEST,
    fetchLocationAlertsSaga
  );
}

export function* FetchAssetsDeviceTypesSaga() {
  yield takeLatest(assetTypes.FETCH_DEVICE_TYPES_REQUEST, fetchDeviceTypesSaga);
}
export function* FetchAssetsSingleDeviceTypesSaga() {
  yield takeLatest(
    assetTypes.FETCH_SINGLE_DEVICE_TYPES_REQUEST,
    fetchSingleDeviceTypesSaga
  );
}

export function* FetchAssetsDeviceNamesSaga() {
  yield takeLatest(assetTypes.FETCH_DEVICE_NAMES_REQUEST, fetchDeviceNamesSaga);
}

export function* FetchAssetsDeviceProfilesSaga() {
  yield takeLatest(
    assetTypes.FETCH_DEVICE_PROFILES_REQUEST,
    fetchDeviceProfilesSaga
  );
}

export function* FetchAssetsLocationsSaga() {
  yield takeLatest(assetTypes.FETCH_LOCATIONS_REQUEST, fetchLocationsSaga);
}

// export function* FetchDeviceCountFromGatewaySaga() {
//   yield takeLatest(
//     assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_REQUEST,
//     fetchDeviceCountFromGateway
//   );
// }

export function* CreateAssetSaga() {
  yield takeLatest(assetTypes.CREATE_REQUEST, createAssetSaga);
}

export function* UpdateAssetSaga() {
  yield takeLatest(assetTypes.UPDATE_REQUEST, updateAssetSaga);
}

export function* DeleteAssetSaga() {
  yield takeLatest(assetTypes.DELETE_REQUEST, deleteAssetSaga);
}

export function* DownloadImageSaga() {
  yield takeLatest(assetTypes.DOWNLOAD_IMAGE_REQUEST, downloadImageSaga);
}
export function* AssetsDownloadSaga() {
  yield takeLatest(assetTypes.DOWNLOAD_REQUEST, downloadSaga);
}

export function* FetchDeviceDetailsSaga() {
  yield takeLatest(assetTypes.FETCH_DEVICE_DETAILS_REQUEST, fetchDeviceDetails);
}

export function* FetchFloorViewSaga() {
  yield takeLatest(assetTypes.FLOOR_VIEW_REQUEST, floorViewSaga);
}
